import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const saveOperationAction = 'saveOperationAction';

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    saveOperationAction({ dispatch, state, commit, rootGetters }, operation) {
      startLoading(dispatch, 'update Opform');
      const opId = rootGetters.getOpid;
      const stateOp = rootGetters['operation_model/entitiesGetter'];
      const op = Object.assign({}, stateOp[opId], operation);
      dispatch('operation_model/upsertEntityAction', op, { root: true })
        .then(() => {
          endLoading(dispatch, 'update Opform');
        })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'update Opform');
        });
    },
  },
  getters: {
  },
};



// WEBPACK FOOTER //
// ./src/features/tab-operation/store.js